import { Directive, ElementRef, AfterViewInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { OlapService } from 'app/service/olap-service.service';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';

@Directive({
    selector: '[input-validate]'
})

export class InputValidateDirective implements AfterViewInit {
    
    @Input('input-validate') params: any;

    constructor(private elem: ElementRef) {}

    ngAfterViewInit() {
        var self = this;
        let errMsg = self.params['errMsg'];
        this.elem.nativeElement.addEventListener('keyup', function() {
            let elemVal = this.value;
            let rule = self.params['rule'];
            let regex = new RegExp(rule);
            if (rule !== undefined) {       
                console.log(elemVal, regex.test(elemVal));
                if (regex.test(elemVal)) {
                    return;
                }
                alert(errMsg);
            }
            return;
        });
    }
}


@Directive({
    selector: '[readFile]'
})
export class ReadFileDirective implements AfterViewInit, OnDestroy {

    @Output() onchange = new EventEmitter<any>();
    @Input() readFile: any;
    rewriteAsJpgAndSubmitSubscription: Subscription;

    constructor(private elemRef: ElementRef,
        private olapService: OlapService) {}

    ngAfterViewInit() {
        try {
            const self = this;
            const previewImg = $(this.readFile.preview);
            $(this.elemRef.nativeElement).change((event: any) => {
                const file = event.target.files[0];
                previewImg.attr('src', '');
                self.rewriteAsJpgAndSubmitSubscription = this.olapService.rewriteAsJpgAndSubmit(file)
                                .subscribe((content: any) => {
                                    previewImg.attr('src', content);
                                    self.onchange.emit({fileResult: content});
                                });
            });
        } catch (err) {
            console.log(err);
        }
    }

    ngOnDestroy() {
        if (this.rewriteAsJpgAndSubmitSubscription) {
            this.rewriteAsJpgAndSubmitSubscription.unsubscribe();
        }
    }
}


// WEBPACK FOOTER //
// /opt/tglfc/olap/salary_web/src/app/directives/util/util.directive.ts